import { useEffect, useState } from 'react'
import './Countdown.css'

export interface CountdownLabels {
  days?: string
  hours?: string
  minutes?: string
  seconds?: string
}

export interface CountdownProps {
  endDate: Date
  labels?: CountdownLabels
}

function computeTimeLeft(endDate: Date) {
  const diff = Math.max(0, endDate.getTime() - Date.now())
  const pad = (n: number) => String(n).padStart(2, '0')
  return {
    d: pad(Math.floor(diff / 86400000)),
    h: pad(Math.floor((diff % 86400000) / 3600000)),
    m: pad(Math.floor((diff % 3600000) / 60000)),
    s: pad(Math.floor((diff % 60000) / 1000)),
  }
}

/** Live-updating days/hours/min/sec countdown to `endDate`. Ticks every second while mounted. */
export function Countdown({ endDate, labels }: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState(() => computeTimeLeft(endDate))

  useEffect(() => {
    setTimeLeft(computeTimeLeft(endDate))
    const id = setInterval(() => setTimeLeft(computeTimeLeft(endDate)), 1000)
    return () => clearInterval(id)
  }, [endDate])

  const units = [
    { value: timeLeft.d, label: labels?.days ?? 'Jours' },
    { value: timeLeft.h, label: labels?.hours ?? 'Heures' },
    { value: timeLeft.m, label: labels?.minutes ?? 'Min' },
    { value: timeLeft.s, label: labels?.seconds ?? 'Sec' },
  ]

  return (
    <div className="azoya-countdown">
      {units.map((u) => (
        <div className="azoya-countdown-unit" key={u.label}>
          <div className="azoya-countdown-value">{u.value}</div>
          <div className="azoya-countdown-label">{u.label}</div>
        </div>
      ))}
    </div>
  )
}
